import { Router, type CanActivateFn } from '@angular/router';
import { UserService } from '../../common/service/user.service';
import { inject } from '@angular/core';
import { Role } from './role.enum';
import { Constants } from '../../common/helper/Constants';

export const CustomerAccessGuard: CanActivateFn = () => {
  const router = inject(Router);
  const userService = inject(UserService);

  const user = userService.currentUser();

  if (user.roles.includes(Role.Customer) && user.customerId === '') {
    return router.parseUrl(Constants.routes.customerAssignmentMissing());
  }

  return true;
};